<template>
  <div :style="{ width: '100%', display: 'flex' }">
    <ValidationProvider
      v-slot="{ errors }"
      :rules="rules"
      :name="label"
      :vid="name"
      :style="{ display: 'flex', alignItems: 'baseline', width  }"
    >
      <CInput
        :invalidFeedback="errors[0]"
        v-model="localValue"
        :isValid="errors[0] ? false : null"
        :name="name"
        style="width: 100%;"
        :placeholder="placeholder"
        :label="withLabel ? label : undefined"
      >
      </CInput>
    </ValidationProvider>
    <span :class="$style['unit']">{{unit}}</span>
    <div v-if="remarks" :class="$style['remarks']">{{ remarks }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    width: {
      type: String,
      default: "200px"
    },
    remarks: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    withLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style module lang="scss">
.remarks {
  font-size: 12px;
  margin-top: 8px;
  margin-left: 24px;
  &:before {
    content: "※";
    margin-right: 4px;
  }
}
.unit {
  margin-top: 4px;
  margin-left: 8px;
}
</style>
